import ChartAverageInterface from "@app/Interface/Chart/ChartAverageInterface";
import ChartMetricInterface from "@app/Interface/Chart/ChartMetricInterface";
import ApiEndpoints from "@app/utils/ApiEndpoints";
import axios from "@app/Security/AxiosAuthentication";
import RollbarHelper from "@app/utils/RollbarHelper";

export default class ChartDataHelper {
    static getChartAveragesData = async (chart: string, fpuId: number, pageId: number): Promise<ChartAverageInterface[]> => {
        const baseUrl: string = process.env.API_BASEURL ?? "";

        const endPoint: string = ApiEndpoints.CHART_AVERAGES + `?page=1&chart_type=${chart}&fpu_id=${fpuId}&page_id=${pageId}` ?? "";

        const url = baseUrl + endPoint;
        let data: ChartAverageInterface[] = [];

        try{
            const response = await axios.get(url, {
                withCredentials: true,
                headers: {
                    "Accept": "application/json"
                }
            });
            // Api Platform updated how collection routes need to return data, a plain object does not cut it anymore
            data = response.data;
        } catch (error) {
            RollbarHelper.logRequestError(error, "getChartAveragesData()");
        }

        return data;
    }

    static getChartMetricsData = async (chart: string, fpuId: number, pageId: number): Promise<ChartMetricInterface> => {
        const baseUrl: string = process.env.API_BASEURL ?? "";

        const endPoint: string = ApiEndpoints.CHART_METRICS + `?page=1&chart_type=${chart}&fpu_id=${fpuId}&page_id=${pageId}` ?? "";

        const url = baseUrl + endPoint;
        let data: ChartMetricInterface = {
            id: 0, producerLow: 0, ndaLow: 0, producerHigh: 0, ndaHigh: 0, producerAverage: 0, ndaAverage: 0
        };

        try{
            const response = await axios.get(url, {
                withCredentials: true,
                headers: {
                    "Accept": "application/json"
                }
            });
            // console.log(response)
            // Api Platform updated how collection routes need to return data, a plain object does not cut it anymore
            data = response.data[0];
        } catch (error) {
            RollbarHelper.logRequestError(error, "getChartMetricsData()");
        }

        return data;
    }
}